import Style from 'ol/style/Style'
import Fill from 'ol/style/Fill'
import Stroke from 'ol/style/Stroke'

export const selectSubdivisionStyle = new Style({
    stroke: new Stroke({
        color: 'yellow',
        width: 5
    }),
    fill: new Fill({
        color: 'rgba(255, 0, 0, 0.1)'
    })
})

export const selectBuildingStyle = new Style({
    stroke: new Stroke({
        color: 'blue',
        width: 5
    }),
    fill: new Fill({
        color: 'rgba(0, 0, 0, 0.3)'
    })
})

export const defaultSubdivisionStyle =  new Style({
    stroke: new Stroke({ color: 'red', width: 1 }),
    fill: new Fill({ color: 'rgba(255, 255, 0, 0.1)' })
})

export const defaultBuildingStyle =  new Style({
    stroke: new Stroke({ color: 'black', width: 1 }),
    fill: new Fill({ color: 'rgba(0, 0, 0, 0.3)' })
})
